import { render } from "./SingleNews.vue?vue&type=template&id=42bbef62&scoped=true"
import script from "./SingleNews.vue?vue&type=script&lang=js"
export * from "./SingleNews.vue?vue&type=script&lang=js"

import "./SingleNews.vue?vue&type=style&index=0&id=42bbef62&lang=scss&scoped=true"

import exportComponent from "/home/forge/binalogue.stage-preview.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42bbef62"]])

export default __exports__